module.exports = __webpack_public_path__ + "img/ic_star_24px@2x.88457080.png";